/* Sela Stone — behavior for all split sections: slider, variants, FAQ, ships-by.
   Idempotent: each [data-sela-pp] root initializes once even if loaded twice. */
(function () {
  'use strict';
  function boot() { document.querySelectorAll('[data-sela-pp]').forEach(init); }

  function init(root) {
    if (root.dataset.selaReady) return;
    root.dataset.selaReady = '1';

    /* ---- variants (hero only) ---- */
    let variants = [];
    try { variants = JSON.parse(root.dataset.variantsJson || '[]'); } catch (e) {}
    const idInput   = root.querySelector('[data-variant-id]');
    const priceEl   = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-compare]');
    const addBtn    = root.querySelector('[data-add]');
    const addText   = root.querySelector('[data-add-text]');
    const optionInputs = root.querySelectorAll('[data-option-input]');
    const optionSelects = root.querySelectorAll('[data-option-select]');
    const ctaLabel  = addText ? addText.textContent.trim() : 'Add to bag';

    /* ---- AJAX add-to-cart -> open theme cart drawer ---- */
    const productForm = root.querySelector('[data-product-form]');
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn && addBtn.getAttribute('disabled')) return;
        const fd = new FormData(productForm);
        if (addBtn) { addBtn.classList.add('is-loading'); addBtn.setAttribute('aria-busy', 'true'); }

        // Sections to re-render for Dawn-style drawers
        const drawerEl = document.querySelector('cart-drawer, cart-notification, #cart-drawer, .cart-drawer, [data-cart-drawer]');
        const bodyDS = (document.querySelector('cart-drawer') || document.querySelector('cart-notification'));
        if (bodyDS && bodyDS.getSectionsToRender) {
          try {
            const ids = bodyDS.getSectionsToRender().map((s) => s.id);
            fd.append('sections', ids.join(','));
            fd.append('sections_url', window.location.pathname);
          } catch (e2) {}
        }

        fetch((window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url + '.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        })
          .then((r) => r.json())
          .then((data) => {
            if (data && data.status) { // error (e.g. sold out)
              if (addBtn) { addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy'); }
              return;
            }
            // 1) Dawn cart-drawer / cart-notification
            const cd = document.querySelector('cart-drawer');
            const cn = document.querySelector('cart-notification');
            if (cn && cn.renderContents) { cn.renderContents(data); }
            else if (cd && cd.renderContents) { cd.renderContents(data); if (cd.open) cd.open(); }
            else {
              // 2) Generic pub/sub used by many themes
              if (window.PUB_SUB_EVENTS && typeof window.subscribe === 'undefined') {}
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data } }));
              document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
              // 3) Try to click a cart-drawer trigger
              const trigger = document.querySelector('[href="/cart"] , [data-cart-drawer-toggle], .js-drawer-open-cart, #cart-icon-bubble');
              if (drawerEl || trigger) {
                if (trigger && trigger.tagName !== 'A') { trigger.click(); }
                else { document.dispatchEvent(new CustomEvent('cart-drawer:open')); }
                if (!drawerEl && !document.querySelector('cart-drawer')) { window.location.href = '/cart'; }
              } else {
                // 4) No drawer in theme — go to cart page
                window.location.href = '/cart';
              }
            }
            if (addBtn) { addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy'); }
          })
          .catch(() => { productForm.submit(); });
      });
    }

    function money(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, (window.theme && theme.moneyFormat) || '${{amount}}');
      }
      return '$' + (cents / 100).toFixed(0);
    }
    function selectedOptions() {
      const out = [];
      root.querySelectorAll('[data-option-input]:checked').forEach((i) => {
        out[parseInt(i.dataset.optionPosition, 10) - 1] = i.value;
      });
      root.querySelectorAll('[data-option-select]').forEach((s) => {
        out[parseInt(s.dataset.optionPosition, 10) - 1] = s.value;
      });
      return out;
    }
    function findVariant(opts) { return variants.find((v) => opts.every((val, i) => v.options[i] === val)); }
    function update() {
      root.querySelectorAll('.ss-picker').forEach((fs) => {
        const c = fs.querySelector('[data-option-input]:checked') || fs.querySelector('[data-option-select]');
        const d = fs.querySelector('[data-selected-value]');
        if (c && d) d.textContent = c.value;
      });
      const v = findVariant(selectedOptions());
      if (!v) { if (addBtn) { addBtn.disabled = true; if (addText) addText.textContent = 'Unavailable'; } return; }
      if (idInput) idInput.value = v.id;
      if (addBtn) addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? ctaLabel : 'Sold out';
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.style.display = ''; }
        else { compareEl.style.display = 'none'; }
      }
      const mid = v.featured_media && v.featured_media.id;
      if (mid) goToMediaId(mid);
      if (history.replaceState) { const u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
    }
    optionInputs.forEach((i) => i.addEventListener('change', () => {
      const mid = i.dataset.variantMediaId; if (mid) goToMediaId(mid); update();
    }));
    optionSelects.forEach((s) => s.addEventListener('change', () => {
      const opt = s.selectedOptions && s.selectedOptions[0];
      const mid = opt && opt.dataset.variantMediaId; if (mid) goToMediaId(mid); update();
    }));

    /* ---- slider gallery (no thumbnails) ---- */
    const track = root.querySelector('[data-slidetrack]');
    const slides = track ? Array.from(track.querySelectorAll('[data-slide]')) : [];
    const dotsWrap = root.querySelector('[data-dots]');
    const prevBtn = root.querySelector('[data-snav-prev]');
    const nextBtn = root.querySelector('[data-snav-next]');
    const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));

    function curIndex() {
      if (!track || !slides.length) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function goTo(i) {
      if (!track || !slides.length) return;
      const idx = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
    }
    function goToMediaId(mid) {
      const i = slides.findIndex((s) => String(s.dataset.mediaId) === String(mid));
      if (i >= 0) goTo(i);
    }
    function syncDots() {
      const idx = curIndex();
      if (dotsWrap) Array.from(dotsWrap.children).forEach((d, i) => d.classList.toggle('is-active', i === idx));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
      if (prevBtn) prevBtn.disabled = idx <= 0;
      if (nextBtn) nextBtn.disabled = idx >= slides.length - 1;
    }
    if (track && slides.length) {
      thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        slides.forEach((_, i) => {
          const b = document.createElement('button');
          b.type = 'button'; b.className = 'ss-dot' + (i === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', 'Go to image ' + (i + 1));
          b.addEventListener('click', () => goTo(i));
          dotsWrap.appendChild(b);
        });
      }
      if (prevBtn) prevBtn.addEventListener('click', () => goTo(curIndex() - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => goTo(curIndex() + 1));
      let raf = 0;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(syncDots); }, { passive: true });
      syncDots();
    }

    /* ---- FAQ accordion ---- */
    root.querySelectorAll('[data-faq] .ss-faq__row').forEach((row) => {
      const q = row.querySelector('[data-faq-q]'); if (!q) return;
      q.addEventListener('click', () => {
        const open = row.classList.contains('is-open');
        row.parentElement.querySelectorAll('.ss-faq__row').forEach((r) => {
          r.classList.remove('is-open');
          const b = r.querySelector('[data-faq-q]'); if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!open) { row.classList.add('is-open'); q.setAttribute('aria-expanded', 'true'); }
      });
    });

    /* ---- rolling ships-by (+3 days) ---- */
    const shipEl = root.querySelector('[data-ships-by]');
    if (shipEl) { const d = new Date(); d.setDate(d.getDate() + 1); shipEl.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) + '.'; }

    /* ---- size guide modal (rings) ---- */
    const sgModal = root.querySelector('[data-sizeguide-modal]');
    if (sgModal) {
      const openBtns = root.querySelectorAll('[data-sizeguide-open]');
      const closeEls = sgModal.querySelectorAll('[data-sizeguide-close]');
      const openSg = () => { sgModal.hidden = false; document.body.classList.add('ss-sg-open'); };
      const closeSg = () => { sgModal.hidden = true; document.body.classList.remove('ss-sg-open'); };
      openBtns.forEach((b) => b.addEventListener('click', openSg));
      closeEls.forEach((b) => b.addEventListener('click', closeSg));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !sgModal.hidden) closeSg(); });
    }

    /* ---- watch band size guide modal (tabbed) ---- */
    const wgModal = root.querySelector('[data-watchguide-modal]');
    if (wgModal) {
      const wgOpen = root.querySelectorAll('[data-watchguide-open]');
      const wgClose = wgModal.querySelectorAll('[data-watchguide-close]');
      const openWg = () => { wgModal.hidden = false; document.body.classList.add('ss-sg-open'); };
      const closeWg = () => { wgModal.hidden = true; document.body.classList.remove('ss-sg-open'); };
      wgOpen.forEach((b) => b.addEventListener('click', openWg));
      wgClose.forEach((b) => b.addEventListener('click', closeWg));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !wgModal.hidden) closeWg(); });
      const wgTabs = Array.from(wgModal.querySelectorAll('[data-wg-tab]'));
      const wgBrandOnly = wgModal.getAttribute('data-wg-default');
      /* brand-specific popup: keep only the matching brand's tab + panels in the DOM */
      if (wgBrandOnly) {
        wgModal.querySelectorAll('[data-wg-panel]').forEach((p) => {
          if (p.getAttribute('data-wg-panel') !== wgBrandOnly) p.remove();
        });
        wgTabs.forEach((t) => {
          if (t.getAttribute('data-wg-tab') !== wgBrandOnly) t.remove();
        });
        /* hide the wrist calculator for brands that have no self-select size table (e.g. Samsung) */
        const wgCalcBlock = wgModal.querySelector('.ss-wg-calc');
        if (wgCalcBlock && !wgModal.querySelector('.ss-wg-panel .ss-wg-table tr[data-wg-size]')) {
          wgCalcBlock.style.display = 'none';
        }
      }
      const wgLiveTabs = () => Array.from(wgModal.querySelectorAll('[data-wg-tab]'));
      const wgLivePanels = () => Array.from(wgModal.querySelectorAll('[data-wg-panel]'));
      const wgActivate = (key) => {
        if (!wgLivePanels().some((p) => p.getAttribute('data-wg-panel') === key)) return;
        wgTabs.forEach((x) => x.classList.toggle('is-active', x.getAttribute('data-wg-tab') === key));
        wgLivePanels().forEach((p) => p.classList.toggle('is-active', p.getAttribute('data-wg-panel') === key));
      };
      wgTabs.forEach((t) => t.addEventListener('click', () => wgActivate(t.getAttribute('data-wg-tab'))));
      if (wgBrandOnly) wgActivate(wgBrandOnly);

      /* wrist calculator: cm -> S/L, highlights matching rows in active panels */
      const wgInput = wgModal.querySelector('[data-wg-calc-input]');
      const wgBtn = wgModal.querySelector('[data-wg-calc-btn]');
      const wgResult = wgModal.querySelector('[data-wg-calc-result]');
      const wgBody = wgModal.querySelector('[data-wg-body]');
      const wgCalc = () => {
        const val = parseFloat((wgInput.value || '').replace(',', '.'));
        wgModal.querySelectorAll('.ss-wg-table tr[data-wg-size]').forEach((r) => r.classList.remove('is-match'));
        if (!val || isNaN(val)) {
          wgResult.hidden = false; wgResult.className = 'ss-wg-calc__result is-warn';
          wgResult.textContent = 'Enter your wrist circumference in inches.';
          return;
        }
        const rows = Array.prototype.slice.call(wgModal.querySelectorAll('.ss-wg-panel.is-active .ss-wg-table tr[data-wg-size]'));
        if (!rows.length) { wgResult.hidden = true; return; }
        const rng = (r) => {
          const lo = parseFloat(r.getAttribute('data-lo'));
          const hi = parseFloat(r.getAttribute('data-hi'));
          if (!isNaN(lo)) return [lo, isNaN(hi) ? lo : hi];
          const nums = (r.children[1].textContent.match(/[\d.,]+/g) || []).map((n) => parseFloat(n.replace(',', '.')));
          return [nums[0], nums.length > 1 ? nums[1] : nums[0]];
        };
        let match = null, below = false, above = false;
        for (let i = 0; i < rows.length; i++) {
          const r = rng(rows[i]);
          if (i === 0 && val < r[0]) { match = rows[0]; below = true; break; }
          if (val <= r[1]) { match = rows[i]; break; }
        }
        if (!match) { match = rows[rows.length - 1]; above = true; }
        const size = match.getAttribute('data-wg-size');
        const variant = match.children[2] ? match.children[2].textContent.trim() : (size + ' (' + match.children[1].textContent.trim() + ')');
        let label;
        if (below) label = 'Closest to ' + variant + ' — you\u2019re just under, size up for comfort.';
        else if (above) label = 'Larger than ' + variant + ' — ' + size + ' is our biggest size.';
        else label = 'Your size is ' + variant + '.';
        wgResult.hidden = false; wgResult.className = 'ss-wg-calc__result is-ok';
        wgResult.innerHTML = '<strong>' + label + '</strong>';
        match.classList.add('is-match');
      };
      if (wgBtn) wgBtn.addEventListener('click', wgCalc);
      if (wgInput) wgInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); wgCalc(); } });

      /* Apple model table + filter */
      const wgSearch = wgModal.querySelector('[data-wg-search]');
      const wgBodyEl = wgModal.querySelector('[data-wg-apple-body]');
      const wgModelsEl = wgModal.querySelector('[data-wg-models]');
      if (wgBodyEl && wgModelsEl) {
        let raw = '';
        try { raw = JSON.parse(wgModelsEl.textContent || '""'); } catch (e) { raw = wgModelsEl.textContent || ''; }
        /* Built-in mm dataset — used when the stored setting is empty or still in the old inch format */
        var WG_APPLE_MM = [
          'Apple Watch Ultra 3 | 2025 | 49mm | 44 / 45 / 46 / 49mm',
          'Apple Watch Series 11 | 2025 | 46mm | 44 / 45 / 46 / 49mm',
          'Apple Watch Series 11 | 2025 | 42mm | 38 / 40 / 41 / 42mm',
          'Apple Watch Series 10 | 2024 | 46mm | 44 / 45 / 46 / 49mm',
          'Apple Watch Series 10 | 2024 | 42mm | 38 / 40 / 41 / 42mm',
          'Apple Watch Ultra 2 | 2023 | 49mm | 44 / 45 / 46 / 49mm',
          'Apple Watch Ultra | 2022 | 49mm | 44 / 45 / 46 / 49mm',
          'Apple Watch Series 9 | 2023 | 45mm | 44 / 45 / 46 / 49mm',
          'Apple Watch Series 9 | 2023 | 41mm | 38 / 40 / 41 / 42mm',
          'Apple Watch SE (2nd gen) | 2022 | 44mm | 44 / 45 / 46 / 49mm',
          'Apple Watch SE (2nd gen) | 2022 | 40mm | 38 / 40 / 41 / 42mm',
          'Apple Watch Series 8 | 2022 | 45mm | 44 / 45 / 46 / 49mm',
          'Apple Watch Series 8 | 2022 | 41mm | 38 / 40 / 41 / 42mm',
          'Apple Watch Series 7 | 2021 | 45mm | 44 / 45 / 46 / 49mm',
          'Apple Watch Series 7 | 2021 | 41mm | 38 / 40 / 41 / 42mm',
          'Apple Watch Series 6 | 2020 | 44mm | 44 / 45 / 46 / 49mm',
          'Apple Watch Series 6 | 2020 | 40mm | 38 / 40 / 41 / 42mm',
          'Apple Watch SE (1st gen) | 2020 | 44mm | 44 / 45 / 46 / 49mm',
          'Apple Watch SE (1st gen) | 2020 | 40mm | 38 / 40 / 41 / 42mm',
          'Apple Watch Series 5 | 2019 | 44mm | 44 / 45 / 46 / 49mm',
          'Apple Watch Series 5 | 2019 | 40mm | 38 / 40 / 41 / 42mm',
          'Apple Watch Series 4 | 2018 | 44mm | 44 / 45 / 46 / 49mm',
          'Apple Watch Series 4 | 2018 | 40mm | 38 / 40 / 41 / 42mm',
          'Apple Watch Series 3 | 2017 | 42mm | 44 / 45 / 46 / 49mm \u26A0\uFE0F',
          'Apple Watch Series 3 | 2017 | 38mm | 38 / 40 / 41 / 42mm',
          'Apple Watch Series 2 | 2016 | 42mm | 44 / 45 / 46 / 49mm \u26A0\uFE0F',
          'Apple Watch Series 2 | 2016 | 38mm | 38 / 40 / 41 / 42mm',
          'Apple Watch Series 1 | 2016 | 42mm | 44 / 45 / 46 / 49mm \u26A0\uFE0F',
          'Apple Watch Series 1 | 2016 | 38mm | 38 / 40 / 41 / 42mm'
        ].join('\n');
        if (!raw || !raw.trim() || /inch/i.test(raw)) { raw = WG_APPLE_MM; }
        const rows = raw.split('\n').map((l) => l.trim()).filter(Boolean).map((l) => {
          const p = l.split('|').map((s) => s.trim());
          return { model: p[0] || '', year: p[1] || '', size: p[2] || '', screen: p[3] || '' };
        });
        rows.forEach((r) => {
          const tr = document.createElement('tr');
          tr.setAttribute('data-wg-row', (r.model + ' ' + r.year + ' ' + r.screen).toLowerCase());
          tr.innerHTML = '<td>' + r.model + '</td><td>' + r.year + '</td><td><strong>' + r.size + '</strong></td><td>' + r.screen + '</td>';
          wgBodyEl.appendChild(tr);
        });
        if (wgSearch) {
          wgSearch.addEventListener('input', () => {
            const term = wgSearch.value.trim().toLowerCase();
            let shown = 0;
            wgBodyEl.querySelectorAll('tr').forEach((tr) => {
              const hit = !term || tr.getAttribute('data-wg-row').includes(term);
              tr.hidden = !hit; if (hit) shown++;
            });
            let empty = wgBodyEl.parentNode.querySelector('[data-wg-empty]');
            if (!shown) {
              if (!empty) { empty = document.createElement('p'); empty.className = 'ss-wg-empty'; empty.setAttribute('data-wg-empty', ''); empty.textContent = 'No match \u2014 try \u201cSeries 9\u201d or \u201cUltra\u201d.'; wgBodyEl.parentNode.appendChild(empty); }
              empty.hidden = false;
            } else if (empty) { empty.hidden = true; }
          });
        }
      }

      /* Fitbit compatibility table + filter */
      const wgFbSearch = wgModal.querySelector('[data-wg-fitbit-search]');
      const wgFbBody = wgModal.querySelector('[data-wg-fitbit-body]');
      const wgFbModels = wgModal.querySelector('[data-wg-fitbit-models]');
      if (wgFbBody && wgFbModels) {
        let raw = '';
        try { raw = JSON.parse(wgFbModels.textContent || '""'); } catch (e) { raw = wgFbModels.textContent || ''; }
        const rows = raw.split('\n').map((l) => l.trim()).filter(Boolean).map((l) => {
          const p = l.split('|').map((s) => s.trim());
          return { model: p[0] || '', year: p[1] || '', status: p[2] || '' };
        });
        rows.forEach((r) => {
          const ok = /^compat/i.test(r.status);
          const tr = document.createElement('tr');
          tr.setAttribute('data-wg-row', (r.model + ' ' + r.year).toLowerCase());
          const cls = ok ? 'ss-wg-compat ss-wg-compat--ok' : 'ss-wg-compat ss-wg-compat--no';
          const txt = ok ? r.status : ('\u26a0\ufe0f ' + r.status);
          tr.innerHTML = '<td>' + r.model + '</td><td>' + r.year + '</td><td><span class="' + cls + '">' + txt + '</span></td>';
          wgFbBody.appendChild(tr);
        });
        if (wgFbSearch) {
          wgFbSearch.addEventListener('input', () => {
            const term = wgFbSearch.value.trim().toLowerCase();
            let shown = 0;
            wgFbBody.querySelectorAll('tr').forEach((tr) => {
              const hit = !term || tr.getAttribute('data-wg-row').includes(term);
              tr.hidden = !hit; if (hit) shown++;
            });
            let empty = wgFbBody.parentNode.querySelector('[data-wg-empty]');
            if (!shown) {
              if (!empty) { empty = document.createElement('p'); empty.className = 'ss-wg-empty'; empty.setAttribute('data-wg-empty', ''); empty.textContent = 'No match \u2014 try \u201cVersa\u201d or \u201cCharge\u201d.'; wgFbBody.parentNode.appendChild(empty); }
              empty.hidden = false;
            } else if (empty) { empty.hidden = true; }
          });
        }
      }
    }

    /* ---- in-buybox review slider ---- */
    const revTrack = root.querySelector('[data-rev-track]');
    if (revTrack) {
      const revSlides = Array.from(revTrack.querySelectorAll('[data-rev-slide]'));
      const revDots = root.querySelector('[data-rev-dots]');
      const revIndex = () => Math.round(revTrack.scrollLeft / revTrack.clientWidth);
      const revGo = (i) => { const idx = Math.max(0, Math.min(revSlides.length - 1, i)); revTrack.scrollTo({ left: idx * revTrack.clientWidth, behavior: 'smooth' }); };
      if (revDots && revSlides.length > 1) {
        revDots.innerHTML = '';
        revSlides.forEach((_, i) => {
          const b = document.createElement('button');
          b.type = 'button'; if (i === 0) b.classList.add('is-active');
          b.setAttribute('aria-label', 'Go to review ' + (i + 1));
          b.addEventListener('click', () => revGo(i));
          revDots.appendChild(b);
        });
        let rraf = 0;
        revTrack.addEventListener('scroll', () => {
          cancelAnimationFrame(rraf);
          rraf = requestAnimationFrame(() => {
            const idx = revIndex();
            Array.from(revDots.children).forEach((d, i) => d.classList.toggle('is-active', i === idx));
          });
        }, { passive: true });
      }
      const revNext = root.querySelector('[data-rev-next]');
      if (revNext && revSlides.length > 1) {
        revNext.addEventListener('click', () => {
          const idx = revIndex();
          revGo(idx >= revSlides.length - 1 ? 0 : idx + 1);
        });
      }
    }

    /* ---- promise line: 2-line clamp + read more ---- */
    root.querySelectorAll('[data-promise]').forEach((pr) => {
      const txt = pr.querySelector('[data-promise-text]');
      const moreBtn = pr.querySelector('[data-promise-more]');
      if (!txt || !moreBtn) return;
      const moreLabel = moreBtn.textContent.trim();
      const lessLabel = moreLabel.replace(/\+\s*$/, '').trim().replace(/^READ MORE/i, 'READ LESS') + ' −';
      const checkClamp = () => {
        if (pr.classList.contains('is-open')) return;
        // overflowing if scrollHeight exceeds clientHeight while clamped
        const clamped = txt.scrollHeight - txt.clientHeight > 2;
        pr.classList.toggle('is-clamped', clamped);
      };
      moreBtn.addEventListener('click', () => {
        const open = pr.classList.toggle('is-open');
        moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        moreBtn.textContent = open ? lessLabel : moreLabel;
      });
      checkClamp();
      window.addEventListener('resize', checkClamp);
    });

    /* ---- description accordion ---- */
    root.querySelectorAll('[data-acc]').forEach((acc) => {
      const head = acc.querySelector('[data-acc-head]');
      if (head) head.addEventListener('click', () => {
        const open = acc.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
